import {
    createContext,
    useContext,
    type Dispatch,
    type ReactNode,
    type SetStateAction,
} from 'react';

export type DashboardLayoutBreakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

interface DashboardLayoutContextValue {
    desktopBreakpoint: DashboardLayoutBreakpoint | null;
    setDesktopBreakpoint: Dispatch<SetStateAction<DashboardLayoutBreakpoint | null>>;
}

const DashboardLayoutContext = createContext<DashboardLayoutContextValue | null>(null);

interface DashboardLayoutProviderProps {
    children: ReactNode;
    desktopBreakpoint: DashboardLayoutBreakpoint | null;
    setDesktopBreakpoint: Dispatch<SetStateAction<DashboardLayoutBreakpoint | null>>;
}

export function DashboardLayoutProvider({
    children,
    desktopBreakpoint,
    setDesktopBreakpoint,
}: DashboardLayoutProviderProps) {
    return (
        <DashboardLayoutContext.Provider
            value={{ desktopBreakpoint, setDesktopBreakpoint }}
        >
            {children}
        </DashboardLayoutContext.Provider>
    );
}

export function useDashboardLayout(): DashboardLayoutContextValue {
    const context = useContext(DashboardLayoutContext);

    if (!context) {
        throw new Error('useDashboardLayout must be used within a DashboardLayoutProvider.');
    }

    return context;
}
